// extracted by mini-css-extract-plugin
module.exports = {"wrapper_container":"style_wrapper_container__CXyYj","table_padding":"style_table_padding__3i9pc"};